<template>
  <div>
    <transition name="slide" enter-active-class="slideInDown" leave-active-class="slideOutUp">
      <div v-if="inCall" class="c-box-call is-success active">
        <div class="c-box-call__inner">
          <div class="row">
            <div class="col-md-6 c-box-call__left">
              <div class="ring-container">
                <div class="ringring"></div>
                <div class="circle"></div>
              </div>
              <div class="c-transcript" v-if="transcript">
                <div class="c-transcript__content">{{ transcript }}</div>
              </div>
            </div>
            <div class="col-md-6 c-box-call__right">
              <div class="c-call-widget" :class="statusIcon">
                <div class="c-call-widget__circle"><i :class="directionIcon"></i></div>
                <div class="c-call-widget__text">{{ $t(direction) }}</div>
              </div>
              <div class="c-call-line"></div>
              <div class="c-call-name">
                <div class="c-call-name__row">
                  <i class="icon12-user-gadient"></i>
                  <b>
                    <a :href="contact&& contact.customer?`/#/customer/${contact.customer._id}`:null">
                      {{ contact ? contact.name : (name ? name : $t('unknown')) }} (
                      <phone-display :phone="number"></phone-display>
                      )
                    </a>
                  </b>
                </div>
                <div v-if="contact && contact.customer" class="c-call-name__row">
                  <i class="icon12-company-gadient"></i><span>{{ contact.customer.name }}</span>
                </div>
              </div>
              <div v-if="callStatus==='accepted'" class="c-call-line"></div>
              <div v-if="callStatus==='accepted'" class="c-box-pad">
                <button @click="mute" :class="isMuted?'disabled':''"><i class="icon24-mute-primary"></i>
                </button>
                <button @click="hold" class="text-primary" :class="isOnHold?'disabled':''" data-toggle="tooltip"
                        data-placement="top" :title="isOnHold?$t('unHold'):$t('hold')">
                  <i class="fa fa-pause"></i>
                </button>
                <button @click="transfer"><i class="icon32-repeat-primary"></i></button>
                <div class="dropdown">
                  <button type="button" @click="showKeypad=!showKeypad"><i class="icon24-dial-primary"></i></button>
                  <div class="dropdown-menu is-custom dropdown-menu-right" :class="showKeypad?'show':null">
                    <div class="dropdown-menu__inner">
                      <div class="c-call-screen">
                        <div class="c-call-screen__row">
                          <div class="c-call-number">
                            <input v-model="keypadInput" class="c-call-number__text">
                            <button @click="backKeypad" class="c-call-number__back"><i class="fa fa-times"></i></button>
                          </div>
                        </div>
                        <div class="c-call-screen__row">
                          <div class="c-push-number">
                            <ul class="clearfix">
                              <li>
                                <button @click="keypadInput+='1'">1</button>
                              </li>
                              <li>
                                <button @click="keypadInput+='2'">2</button>
                              </li>
                              <li>
                                <button @click="keypadInput+='3'">3</button>
                              </li>
                              <li>
                                <button @click="keypadInput+='4'">4</button>
                              </li>
                              <li>
                                <button @click="keypadInput+='5'">5</button>
                              </li>
                              <li>
                                <button @click="keypadInput+='6'">6</button>
                              </li>
                              <li>
                                <button @click="keypadInput+='7'">7</button>
                              </li>
                              <li>
                                <button @click="keypadInput+='8'">8</button>
                              </li>
                              <li>
                                <button @click="keypadInput+='9'">9</button>
                              </li>
                              <li>
                                <button @click="keypadInput+='*'">*</button>
                              </li>
                              <li>
                                <button @click="keypadInput+='0'">0</button>
                              </li>
                              <li>
                                <button @click="keypadInput+='#'">#</button>
                              </li>
                            </ul>
                          </div>
                        </div>
                        <div v-if="keypadInput" class="c-call-screen__row">
                          <button @click="sendKeypad" class="btn btn-primary btn-block btn-lg" type="button">Ok</button>
                        </div>
                      </div>
                      <!-- c-call-screen-->
                    </div>
                  </div>
                </div>
              </div>
              <div class="c-call-line"></div>
              <div class="c-box-call__time">
                <span v-if="isOnHold">{{ $t('onHold') }}</span>
                <span v-else-if="isMuted">{{ $t('microphoneMuted') }}</span>
                <span v-else>{{ $t(callStatus) }}</span>
                <span v-if="callStatus==='accepted'"> - {{ duration | callDuration }}</span>
              </div>
              <div class="c-box-call__ok" v-if="direction==='incoming' && ['new'].includes(callStatus)">
                <button @click="answerCall" class="btn btn-success btn-sm is-border-circle" type="button">
                  <i class="icon12-phone-white icon-left"></i>{{ $t('answer') }}
                </button>
              </div>
              <div class="c-box-call__end" v-if="callStatus!=='ended'">
                <button v-if="callStatus==='ending'" class="btn btn-danger" type="button">
                  <b-spinner></b-spinner>
                </button>
                <button v-else @click="endCall" class="btn btn-danger" type="button">
                  <i class="icon16-call-end-white"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>
    <b-modal v-model="showTransferForm" :title="$t('transfer')" @ok="transferCall" ok-only :no-close-on-backdrop="true" :no-enforce-focus="true">
      <b-form-group :label="$t('transferNumber')">
        <b-form-input v-model="transferNumber" :placeholder="$t('transferNumber')"></b-form-input>
      </b-form-group>
    </b-modal>
  </div>
</template>

<script>
import console from 'console';
import $ from 'jquery';
import PhoneDisplay from "./PhoneDisplay";

export default {
  components: {PhoneDisplay},
  data: function () {
    return {
      callId: null,
      inCall: false,
      showTransferForm: false,
      direction: null,
      duration: 0,
      durationTimer: null,
      number: '',
      transferNumber: '',
      name: null,
      contact: null,
      phoneStatus: 'pending',
      callStatus: null,
      phone: null,
      call: null,
      isMuted: false,
      isOnHold: false,
      showKeypad: false,
      keypadInput: '',
      recognition: null,
      transcripts: [],
      transcript: null,
      checkPhone: false
    }
  },
  computed: {
    directionIcon() {
      if (this.direction === 'incoming') {
        return 'icon12-call-callin-white';
      }
      return 'icon12-call-callout-white';
    },
    statusIcon() {
      if (!this.callStatus) {
        return 'is-warning';
      }
      if (this.callStatus === 'ended') {
        return 'is-danger';
      }
      if (this.callStatus === 'accepted') {
        return 'is-success';
      }
      return 'is-warning';
    }
  },
  watch: {
    inCall(val) {
      if (val) {
        $('body').addClass('active-call');
      } else {
        $('body').removeClass('active-call');
      }
    }
  },
  methods: {
    makeCall(number, campaignId) {
      if (this.$store.state.phoneStatus !== 'connected') {
        this.$swal({
          text: this.$t('phoneDisconnected'),
          icon: 'warning'
        });
        return;
      }
      if (number) {
        this.number = number.replace(/\D/g, '');
      } else {
        this.number = '';
      }
      if (this.number && this.number !== '') {
        this.number = this.number.trim();
        if (this.callStatus === null || this.callStatus === 'ended' || !this.inCall || !this.$store.state.inCall) {
          if (this.recognition) {
            try {
              this.recognition.start();
            } catch (e) {
              console.log(e);
            }
          }
          if (window.ReactNativeWebView) {
            window.ReactNativeWebView.postMessage(JSON.stringify({
              type: 'makeCall',
              data: {
                number: this.number,
                callerNumber: this.$store.state.callerNumber
              }
            }));
          }
          if (window.webkit && window.webkit.messageHandlers.iOSNative) {
            window.webkit.messageHandlers.iOSNative.postMessage({
              type: 'makeCall',
              number: this.number,
              callerNumber: this.$store.state.callerNumber,
              campaignId: campaignId
            });
          }
          if (window.androidNative) {
            window.androidNative.postMessage(JSON.stringify({
              type: 'makeCall',
              number: this.number,
              callerNumber: this.$store.state.callerNumber,
              campaignId: campaignId
            }));
          }
          this.loadContact();

        } else {
          this.$swal({
            text: this.$t('otherCallInProgress'),
            icon: 'warning'
          });
        }
      } else {
        this.$swal({
          text: this.$t('phoneNumberRequired'),
          icon: 'warning'
        });
      }
    },
    endCall() {
      this.callStatus = 'ending';
      if (window.ReactNativeWebView) {
        window.ReactNativeWebView.postMessage(JSON.stringify({
          type: 'endCall',
          data: {}
        }));
      }
      if (window.webkit && window.webkit.messageHandlers.iOSNative) {
        window.webkit.messageHandlers.iOSNative.postMessage({
          type: 'endCall',
        });
      }
      if (window.androidNative) {
        window.androidNative.postMessage(JSON.stringify({
          type: 'endCall',
          data: {}
        }));
      }
    },

    mute() {
      if (this.isMuted == false) {
        if (window.ReactNativeWebView) {
          window.ReactNativeWebView.postMessage(JSON.stringify({
            type: 'mute',
            data: {}
          }));
        }
        if (window.webkit && window.webkit.messageHandlers.iOSNative) {
          window.webkit.messageHandlers.iOSNative.postMessage({
            type: 'mute',
          });
        }
        if (window.androidNative) {
          window.androidNative.postMessage(JSON.stringify({
            type: 'mute'
          }));
        }
        this.isMuted = true;
      } else {
        if (window.ReactNativeWebView) {
          window.ReactNativeWebView.postMessage(JSON.stringify({
            type: 'unmute',
            data: {}
          }));
        }
        if (window.webkit && window.webkit.messageHandlers.iOSNative) {
          window.webkit.messageHandlers.iOSNative.postMessage({
            type: 'unmute',
          });
        }
        if (window.androidNative) {
          window.androidNative.postMessage(JSON.stringify({
            type: 'unmute'
          }));
        }
        this.isMuted = false;
      }
    },
    hold() {
      if (this.isOnHold == false) {
        if (window.ReactNativeWebView) {
          window.ReactNativeWebView.postMessage(JSON.stringify({
            type: 'hold',
            data: {}
          }));
        }
        if (window.webkit && window.webkit.messageHandlers.iOSNative) {
          window.webkit.messageHandlers.iOSNative.postMessage({
            type: 'hold',
          });
        }
        if (window.androidNative) {
          window.androidNative.postMessage(JSON.stringify({
            type: 'hold',
          }));
        }
        this.isOnHold = true;
      } else {
        if (window.ReactNativeWebView) {
          window.ReactNativeWebView.postMessage(JSON.stringify({
            type: 'unhold',
            data: {}
          }));
        }
        if (window.webkit && window.webkit.messageHandlers.iOSNative) {
          window.webkit.messageHandlers.iOSNative.postMessage({
            type: 'unhold',
          });
        }
        if (window.androidNative) {
          window.androidNative.postMessage(JSON.stringify({
            type: 'unhold',
          }));
        }
        this.isOnHold = false;
      }
    },
    transfer() {
      this.showTransferForm = true;
    },
    transferCall() {
      if (this.transferNumber && this.transferNumber.trim() !== '') {
        if (window.ReactNativeWebView) {
          window.ReactNativeWebView.postMessage(JSON.stringify({
            type: 'transfer',
            data: {transferNumber: this.transferNumber}
          }));
        }
        if (window.webkit && window.webkit.messageHandlers.iOSNative) {
          window.webkit.messageHandlers.iOSNative.postMessage({
            type: 'transfer',
            number: this.transferNumber
          });
        }
        if (window.androidNative) {
          window.androidNative.postMessage(JSON.stringify({
            type: 'transfer',
            data: {number: this.transferNumber}
          }));
        }
      }
      this.transferNumber = '';
      this.showTransferForm = false;
    },
    sendKeypad() {
      if (this.keypadInput.length) {
        if (window.ReactNativeWebView) {
          window.ReactNativeWebView.postMessage(JSON.stringify({
            type: 'sendDTMF',
            data: {keypadInput: this.keypadInput}
          }));
        }
        if (window.webkit && window.webkit.messageHandlers.iOSNative) {
          window.webkit.messageHandlers.iOSNative.postMessage({
            type: 'sendDTMF',
            key: this.keypadInput
          });
        }
        if (window.androidNative) {
          window.androidNative.postMessage(JSON.stringify({
            type: 'sendDTMF',
            data: {keypadInput: this.keypadInput}
          }));
        }
      }
      this.keypadInput = '';
      this.showKeypad = false;
    },
    backKeypad() {
      if (this.keypadInput.length) {
        this.keypadInput = this.keypadInput.slice(0, -1);
      }
    },
    loadContact() {
      this.contact = null;
      if (this.number && this.number.length > 6) {
        let keyword = this.number;
        let countryPrefix = this.$store.state.user.client.country.phonePrefix;
        let prefixRegex = new RegExp(`^(\\+${countryPrefix}|00${countryPrefix}|${countryPrefix}|0)([0-9]+)$`);
        if (prefixRegex.test(keyword)) {
          keyword = keyword.replace(prefixRegex, '$2')
        }
        this.$bgService.get('/contact', {
          params: {
            phone: keyword,
            page: 1,
            pageSize: 1
          }
        }).then(response => {
          if (response.data.docs.length > 0) {
            this.contact = response.data.docs[0];
          } else {
            this.contact = null;
          }
        }).catch(() => {
          this.contact = null;
        });
      } else {
        this.contact = null;
      }
    },
    submitTranscript() {
      if (this.recognition) {
        try {
          this.recognition.stop();
        } catch (e) {
          console.log(e);
        }
      }
      if (this.transcripts.length) {
        this.$bgService.post('/call/transcripts', {
          callId: this.callId,
          transcripts: this.transcripts
        }).then(() => {
          this.transcript = null;
          this.transcripts = [];
        });
      } else {
        this.transcript = null;
        this.transcripts = [];
      }
    },
    connect() {
      if (this.checkPhone) {
        return;
      }
      this.$store.commit('phoneStatus', 'connecting');
      if (window.ReactNativeWebView) {
        window.ReactNativeWebView.postMessage(JSON.stringify({
          type: 'connect',
          data: {
            domain: this.$store.state.user.client.domain,
            ext: this.$store.state.user.ext,
            extPassword: this.$store.state.user.extPassword,
            token: localStorage.getItem('token')
          }
        }));
        this.checkPhone = true;
      }
      if (window.webkit && window.webkit.messageHandlers.iOSNative) {
        window.webkit.messageHandlers.iOSNative.postMessage({
          type: 'connect',
          domain: this.$store.state.user.client.domain,
          ext: this.$store.state.user.ext,
          extPassword: this.$store.state.user.extPassword,
          token: localStorage.getItem('token')
        });
        this.checkPhone = true;
      }
      if (window.androidNative) {
        window.androidNative.postMessage(JSON.stringify({
          type: 'connect',
          data: {
            domain: this.$store.state.user.client.domain,
            ext: this.$store.state.user.ext,
            extPassword: this.$store.state.user.extPassword,
            token: localStorage.getItem('token')
          }
        }));
        this.checkPhone = true;
      }
    },
    disconnect() {
      if (window.ReactNativeWebView) {
        window.ReactNativeWebView.postMessage(JSON.stringify({
          type: 'disconnect',
          data: {}
        }));
      }
      if (window.webkit && window.webkit.messageHandlers.iOSNative) {
        window.webkit.messageHandlers.iOSNative.postMessage({
          type: 'disconnect'
        });
      }
      if (window.androidNative) {
        window.androidNative.postMessage(JSON.stringify({
          type: 'disconnect',
        }));
      }
    },
    callStatusUpdated(callId) {
      this.callId = callId;
      this.$bus.$emit("callStatusUpdated", this.number, callId, this.callStatus);
    },
    answerCall() {
      this.callStatus = 'progress';
      if (window.ReactNativeWebView) {
        window.ReactNativeWebView.postMessage(JSON.stringify({
          type: 'answerCall',
          data: {}
        }));
      }
      if (window.webkit && window.webkit.messageHandlers.iOSNative) {
        window.webkit.messageHandlers.iOSNative.postMessage({
          type: 'answerCall'
        });
      }
      if (window.androidNative) {
        window.androidNative.postMessage(JSON.stringify({
          type: 'answerCall'
        }));
      }
    },
    handleMsg(msg) {
      let data = JSON.parse(msg);
      switch (data.type) {
        case 'registered':
          this.$store.commit('phoneStatus', 'connected');
          break;
        case 'registering':
          this.$store.commit('phoneStatus', 'connecting');
          break;
        case 'disconnected':
          this.$store.commit('phoneStatus', 'disconnected');
          break;
        case 'makeCall':
          this.direction = 'outgoing';
          this.callStatus = 'new';
          this.inCall = true;
          this.$store.state.inCall = true;
          this.isMuted = false;
          this.isOnHold = false;
          this.callStatusUpdated(data.data.callId);
          break;
        case 'progress':
          this.callStatus = 'progress';
          this.callStatusUpdated(data.data.callId);
          break;
        case 'connecting':
          this.callStatus = 'connecting';
          this.callStatusUpdated(data.data.callId);
          break;
        case 'accepted':
          this.callStatus = 'accepted';
          this.$bus.$emit('titleNotificationOff');
          if (this.durationTimer) {
            clearInterval(this.durationTimer);
          }
          if (this.call.direction === "incoming") {
            this.$bus.$emit("newIssueManually");
          }
          this.duration = 0;
          this.durationTimer = setInterval(() => {
            this.duration++;
          }, 1000);
          this.callStatusUpdated(data.data.callId);
          break;
        case 'endCall':
          this.callStatus = 'ended';
          setTimeout(() => {
            if (!this.$store.state.inCall) {
              this.inCall = false;
            }
          }, 1000);
          this.showKeypad = false;
          this.keypadInput = '';
          this.$store.state.inCall = false;
          this.$bus.$emit('titleNotificationOff');
          this.callStatusUpdated(data.data.callId);
          this.submitTranscript();
          this.$bus.$emit('eliminateNum');
          break;
        case 'incomingCall':
          this.inCall = true;
          this.$store.state.inCall = true;
          this.direction = 'incoming';
          this.callStatus = 'new';
          this.isMuted = false;
          this.isOnHold = false;
          this.number = data.data.number;
          this.name = data.data.name;
          this.loadContact();
          this.$bus.$emit('titleNotification', this.$t('incomingCallNotification', [this.number]));
          this.$notification.show(this.$t('incomingCall'), {
            body: this.$t('incomingCallNotification', [this.number]),
            vibrate: true,
            requireInteraction: true
          }, {});
          this.callStatusUpdated(data.data.callId);
          break;
        default:
          break;
      }
    }
  },
  mounted() {
    this.connect();
    window.addEventListener("message", (msg) => {       // Message from IOS
      this.handleMsg(msg.data);
    }, false);

    document.addEventListener("message", (msg) => {     // Message from Android
      this.handleMsg(msg.data);
    }, false);

    this.$bus.$on('disconnectPhone', this.disconnect);
    this.$bus.$on('makeCall', this.makeCall);
    this.$bus.$on('answerCall', this.answerCall);
    this.$bus.$on('endCall', this.endCall);
    if ((window.webkit && window.webkit.messageHandlers.iOSNative) || window.androidNative) {
      this.$bus.$on('deviceMessage', this.handleMsg);
    }
  },
  beforeDestroy() {
    this.$bus.$off('disconnectPhone');
    this.$bus.$off('makeCall');
    this.$bus.$off('answerCall');
    this.$bus.$off('endCall');
    this.$bus.$off('deviceMessage');
    this.endCall();
  }
}
</script>